import { FaCheck } from "react-icons/fa";

interface PropTypes {
    completed?: boolean,
    id: string,
    labelText?: string,
    checked?: boolean,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    borderColor?: string;
    bgColor?: string;
    style?: {
      color?: string;
      backgroundColor?: string;
      border?: string;
      fontSize?: string;
    };
}

export default function Checkbox({ 
    completed, 
    id, 
    labelText, 
    checked, 
    onChange,
    style
}: PropTypes) {
    const isCompletedProvided = typeof completed === 'boolean';
    return (
        <label 
          htmlFor={id} 
          className={`flex items-center bg-primary w-full md:w-max text-white px-4 py-1 rounded-md gap-2 select-none justify-start`}
          style={style}
        >
            <input 
              type="checkbox"
              className={`hidden`}
              id={id}
              onChange={onChange} 
              checked={checked} 
              disabled={isCompletedProvided ? completed : false}
            />
            <div
              className={
                `w-5 h-5 flex-shrink-0 flex items-center justify-center border-2 border-primary rounded-sm sm:rounded-md transition-colors duration-150 ${completed ? 'cursor-not-allowed' : 'cursor-pointer'}
                ${checked ? "bg-primary" : "bg-white"}`
              }
            >
              {checked && <FaCheck className="text-white" size={12} />}
            </div>
            <span className=" whitespace-nowrap w-max">
              {labelText}
            </span>
        </label>
    )
}
